import { DebugLogger } from 'lib/debugLogger';
import { features } from 'reactApp/mail-features';
import type { QuotaStates } from 'server/types/context/IUser';

export const overquotaStatesWithQuotaCheck = features.getAsArray('overquota-states-with-quota-check', [
    'started',
    'blocked',
    'unblocked',
    'full_blocked',
]) as QuotaStates[];

export const overquotaStatesWithoutQuotaCheck = features.getAsArray('overquota-states-without-quota-check', [
    'cleared',
    'after_clear',
]) as QuotaStates[];

// Фича для проверки правильности разделения по трешхолдам в омикроне
export const overquotaThresholdLabel = features.getAsString('overquota-threshold-label');

export const isStateWithQuotaCheck = (state?: QuotaStates) => {
    if (!state) {
        return false;
    }

    return overquotaStatesWithQuotaCheck.includes(state);
};

export const overquotaDebug = features.has('overquota-debug');
export const overquotaDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'OverquotaDebug', DEBUG: overquotaDebug });
